module.exports = __webpack_public_path__ + "static/SLFCspread-4-9d98afe7ea47b3dbb434f408c18c0177.jpg";